import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Just assign the class name to "),
  /*#__PURE__*/_createVNode("code", null, "el-icon-iconName"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Default")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Primary")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Success")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Info")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Warning")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Danger")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Plain")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Primary")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Success")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Info")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Warning")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Danger")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Round")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Primary")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Success")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Info")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Warning")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Danger")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "success" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "info" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "warning" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "danger" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { plain: "" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "info",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { round: "" }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "info",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: "el-icon-search",
            circle: ""
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-edit c-white",
            circle: ""
          }),
          _createVNode(_component_el_button, {
            type: "success",
            icon: "el-icon-check c-white",
            circle: ""
          }),
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-message c-white",
            circle: ""
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            icon: "el-icon-star-off c-white",
            circle: ""
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            icon: "el-icon-delete c-white",
            circle: ""
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}